<p>Ange lån, bindningstid och belåningsgrad (ltv) för att beräkna internräntan.</p>
<div class="simulator">
  <mat-form-field class="input-parent">
    <mat-label>Produkt</mat-label>
    <mat-select [(ngModel)]="product">
      @for (loan of LoanProductMap | keyvalue : sortOriginal; track $index) {
        <mat-option [value]="loan.key">{{ loan.value }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="input-parent" style="width: 140px">
    <mat-label>Bindningstid</mat-label>
    <mat-select [(ngModel)]="binding" panelWidth="200">
      <mat-option [value]="3">{{ 3 | binding }}</mat-option>
      <mat-option [value]="12">1 år</mat-option>
      <mat-option [value]="24">2 år</mat-option>
      <mat-option [value]="36">3 år</mat-option>
      <mat-option [value]="48">4 år</mat-option>
      <mat-option [value]="60">5 år</mat-option>
      <mat-option [value]="84">7 år</mat-option>
      <mat-option [value]="120">10 år</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="input-parent" style="width: 90px;">
    <mat-label>LTV</mat-label>
    <input matInput spbFormatNumber [(ngModel)]="ltv">
    <span matTextSuffix>%</span>
  </mat-form-field>

</div>
<div>
  <p>Detta är den beräknade internräntan baserat på:</p>
  <ul>
    <li>Vald produkt ({{ product() | loanProduct }} {{ product() }})</li>
    <li>Den valda bindningstiden, 3 mån - 10 år ({{ binding() | binding }})</li>
    <li>Belåningsgrad, kolumn: {{ ltvColumn() }} % (avrundat)</li>
  </ul>
  <p>Baserat på indata har vi kommit fram till <i>Internränta</i>:
    <b>{{ internalEmulatedInterest() | number : '1.2-2': 'sv-SE' }}</b> %</p>
  <div style="display: none">{{ emulatorValues() | json}}</div>
</div>